<div class="row">
	<div class="col-12">
		<div class="notFound">
		  <div class="notFoundInner">
		    <img src="../../../assets/img/404.png" class="img-fluid">
		    <button [routerLink]="['/']" class="button mt-2">Go Back To Arrivae</button>
		  </div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/pagenotfound/pagenotfound.component.html